(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_guide-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('guide-gallery')) {
    customElements.define('guide-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.guide-gallery__track');
        this.slides = [...this.querySelectorAll('.guide-gallery-slide')];
        const thumbnails = this.querySelector('.guide-gallery__thumbnails');
        if (!this.track || this.slides.length < 2) return;
        thumbnails.replaceChildren();
        this.buttons = this.slides.map((slide, index) => {
          const source = slide.querySelector('img');
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'guide-gallery__thumbnail';
          button.setAttribute('aria-label', slide.dataset.label || source?.alt || String(index + 1));
          button.setAttribute('aria-controls', this.track.id);
          if (source) {
            const image = document.createElement('img');
            image.src = source.dataset.thumbnail || source.currentSrc || source.src;
            image.alt = '';
            image.width = 60;
            image.height = 60;
            button.append(image);
          }
          button.addEventListener('click', () => this.go(index), options);
          thumbnails.append(button);
          return button;
        });
        this.previous = this.querySelector('[data-gallery-previous]');
        this.next = this.querySelector('[data-gallery-next]');
        this.previous.addEventListener('click', () => this.go(this.index - 1), options);
        this.next.addEventListener('click', () => this.go(this.index + 1), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index + (event.key === 'ArrowRight' ? direction : -direction));
          }
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.indexOf(event.target.closest('.guide-gallery-slide'));
          if (index >= 0) this.go(index, true);
        }, options);
        this.querySelector('.guide-gallery__controls').hidden = false;
        thumbnails.hidden = false;
        this.update();
      }
      go(index, immediate = false) {
        const slide = this.slides[Math.max(0, Math.min(index, this.slides.length - 1))];
        const offset = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollTo({ left: this.track.scrollLeft + offset, behavior: immediate || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        const left = this.track.getBoundingClientRect().left;
        this.index = this.slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(this.slides[best].getBoundingClientRect().left - left) ? index : best, 0);
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index === this.slides.length - 1;
        this.buttons.forEach((button, index) => button.setAttribute('aria-current', String(index === this.index)));
        this.querySelector('.guide-gallery__count').textContent = `${this.index + 1} / ${this.slides.length}`;
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["guide-image"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('guide-sample')) {
    customElements.define('guide-sample', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('click', (event) => {
          const dialog = this.querySelector('dialog');
          if (!dialog) return;
          const opener = event.target.closest('[data-sample-open]');
          if (opener && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
            event.preventDefault();
            const image = dialog.querySelector('[data-sample-full]');
            if (!image.getAttribute('src')) image.src = image.dataset.src;
            dialog.showModal();
          }
          const zoom = event.target.closest('[data-sample-zoom]');
          if (zoom) {
            const zoomed = dialog.querySelector('.guide-image__reader').classList.toggle('guide-image__reader--zoomed');
            zoom.setAttribute('aria-pressed', String(zoomed));
            zoom.textContent = zoomed ? zoom.dataset.fitLabel : zoom.dataset.zoomLabel;
          }
          if (event.target === dialog) dialog.close();
        }, {signal: this.controller.signal});
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
